module.exports = __webpack_public_path__ + "static/google-copy-823cf2890eef0e80455582bc20c6e85c.png";